import { AlertTriangle } from 'lucide-react';
import { Link, useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function ErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();
  const message = error instanceof Error ? error.message : t('errors.unexpected');
  return (
    <main className="content-wrap page-hero" id="main-content">
      <div className="empty-state" role="alert">
        <AlertTriangle size={42} aria-hidden="true" />
        <h1>{t('errors.title')}</h1>
        <p>{t('errors.generic')}</p>
        {import.meta.env.DEV && <pre dir="ltr" style={{ maxWidth: '100%', whiteSpace: 'pre-wrap' }}>{message}</pre>}
        <Link className="button" to="/">{t('navigation.home')}</Link>
      </div>
    </main>
  );
}
